export default "__VITE_ASSET__xBxOt8Kz__"